import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import usePermissions from '../hooks/usePermissions';
import { AccessDeniedPage } from './PermissionGuard';

export default function BookingWorkflowGuard({ action, children }: { action: 'view' | 'create' | 'edit'; children: ReactNode }) {
  const { hasPermission } = usePermissions();
  const [params] = useSearchParams();
  const required = action === 'create' && params.has('upgrade') ? 'edit' : action;
  return hasPermission(`bookings.${required}`) ? <>{children}</> : <AccessDeniedPage />;
}
